import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import { SchedulingHistory } from './scheduling-history';
import { SchedulingHistoryDetail } from './scheduling-history-detail';
import { SchedulingHistoryUpdate } from './scheduling-history-update';
import { SchedulingHistoryDeleteDialog } from './scheduling-history-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={SchedulingHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={SchedulingHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={SchedulingHistoryDetail} />
      <ErrorBoundaryRoute path={match.url} component={SchedulingHistory} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={SchedulingHistoryDeleteDialog} />
  </>
);

export default Routes;
